module.exports = __webpack_public_path__ + "static/img/icon_banner_prev_dark.1ad734d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_banner_prev_dark.svg
// module id = oskA
// module chunks = 10